var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "drag-panel" }, [
      _c(
        "span",
        { staticClass: "material-icons", staticStyle: { "font-size": "30px" } },
        [_vm._v("ads_click")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [
        _vm._v("Select the right place to add to block"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }